import React from 'react';
import {
  Menu,
  MenuItem,
  SubMenu
} from '@szhsin/react-menu';
import '@szhsin/react-menu/dist/index.css';
import '@szhsin/react-menu/dist/transitions/slide.css';
import PropTypes from 'prop-types';

function Dropdown({ menuButton, className, children, render, ...rest}) {
  return (
    <Menu
      menuButton={menuButton}
      transition
      menuClassName={"rounded-1"}
      {...rest}
    >
      {
        render({
          MenuItem,
          SubMenu
        })
      }
    </Menu>
  );
}

Dropdown.defaultProps = {
  menuButton: null,
  render: () => null,
  arrow: true,
  viewScroll : "close"
};

Dropdown.propTypes = {
  menuButton: PropTypes.element.isRequired,
  render: PropTypes.func.isRequired
};

export default  Dropdown